// Action tabs for reusability across components
export const leftActionTabs = [
  {
    id: "back",
    name: "Back",
    icon: "ArrowBack",
    color: "primary",
    variant: "outlined",
  },
];

export const rightActionTabs = [
  {
    id: "add",
    name: "Add",
    icon: "Add",
    color: "primary",
    variant: "contained",
  },
  {
    id: "update",
    name: "Update",
    icon: "Edit",
    color: "secondary",
    variant: "contained",
  },
];

// Combined action tabs for flexible filtering
export const allActionTabs = [...leftActionTabs, ...rightActionTabs];

// Utility to filter tabs by IDs
export const getActionTabs = (allowedIds = []) => {
  return allActionTabs.filter((tab) => allowedIds.includes(tab.id));
};
